export default __webpack_public_path__ + "static/media/585_4.f91ac4db.jpg";